// SCRIPT FOR BRIDGE KIT PAGE

// seamless reviews/testimonials scroll. 3 total duplicates
const scrollContainer = document.querySelector('.scroll-container');
const track = document.querySelector('.testimonials-track');

const existingTracks = document.querySelectorAll('.testimonials-track').length;

const neededClones = 3 - existingTracks;

for (let i = 0; i < neededClones; i++) {
    const clone = track.cloneNode(true);
    scrollContainer.appendChild(clone);
}

// accordion functionality
const accordionItems = document.querySelectorAll('.accordion-item');
const accordionHeaders = document.querySelectorAll('.accordion-header');

accordionHeaders.forEach((header, index) => {
    header.addEventListener('click', () => {
        const item = accordionItems[index];
        const isActive = item.classList.contains('active');

        accordionItems.forEach(item => {
            item.classList.remove('active');
            item.querySelector('.accordion-header').setAttribute('aria-expanded', 'false');
        });

        if (!isActive) {
            item.classList.add('active');
            header.setAttribute('aria-expanded', 'true');
        }
    });
});

// features swiper
const swiper = new Swiper('.featuresSwiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    loopAdditionalSlides: 2,
    autoplay: {
        delay: 3000,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1921: {
            slidesPerView: 3,
        },
    }
});

// auto-play videos when slide is active
swiper.on('slideChange', function () {
    // pause videos
    document.querySelectorAll('.swiper-slide video').forEach(video => {
        video.pause();
        video.currentTime = 0;
    });

    // play videos in all visible slides
    const visibleSlides = swiper.slides.filter((slide, index) => {
        return index >= swiper.activeIndex && index < swiper.activeIndex + swiper.params.slidesPerView;
    });
    
    visibleSlides.forEach(slide => {
        const videos = slide.querySelectorAll('video');
        videos.forEach(video => {
            video.play();
        });
    });
});

// play videos in initial visible slides
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        const visibleSlides = swiper.slides.filter((slide, index) => {
            return index >= swiper.activeIndex && index < swiper.activeIndex + swiper.params.slidesPerView;
        });
        
        visibleSlides.forEach(slide => {
            const videos = slide.querySelectorAll('video');
            videos.forEach(video => {
                video.play();
            });
        });
    }, 100);
});

// pause autoplay when hovering over cards
document.querySelectorAll('.feature-card').forEach(card => {
    card.addEventListener('mouseenter', () => {
        swiper.autoplay.stop();
    });
    
    card.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
    });
});

// youtube videos
const videos = [
    {
        id: 'OcokK7KmOOQ',
        title: 'Extend Full-Speed Wi-Fi to Detached Garage, Barn or Second House - EAP211-Bridge Kit',
        thumbnail: 'https://img.youtube.com/vi/OcokK7KmOOQ/hqdefault.jpg'
    },
    {
        id: 'rGQ8AR8xQAU',
        title: 'Finally full speed Wi-Fi in the house! Extend the Homelab WiFi under $90! - Omada EAP211 Bridge Kit',
        thumbnail: 'https://img.youtube.com/vi/rGQ8AR8xQAU/maxresdefault.jpg'
    },
    {
        id: '6bYww0zTcVk',
        title: 'Omada EAP211-Bridge KIT: The Easiest Way to Link Two Locations Wirelessly!',
        thumbnail: 'https://img.youtube.com/vi/6bYww0zTcVk/maxresdefault.jpg'
    },
    {
        id: 'ql8it2nU_g4',
        title: '✅ Send Wi-Fi To Another Building - TP-Link Omada EAP215-Bridge Kit Wi-FI to Island - No Ethernet',
        thumbnail: 'https://img.youtube.com/vi/ql8it2nU_g4/maxresdefault.jpg'
    },
    {
        id: 'n6C4nT0hsrg',
        title: 'How to set up the Omada EAP Bridge Kit',
        thumbnail: 'https://img.youtube.com/vi/n6C4nT0hsrg/maxresdefault.jpg'
    }
];

let player;
let currentVideoIndex = 0;
let playerInitialized = false;

// Initialize YouTube Player
function initYouTubePlayer() {
    if (playerInitialized) return; // Prevent duplicate initialization

    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        // API not ready yet, wait and try again
        setTimeout(initYouTubePlayer, 100);
        return;
    }

    playerInitialized = true;
    player = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: videos[0].id,
        playerVars: {
            autoplay: 1,
            rel: 0,
            mute: 1,
            modestbranding: 1
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange
        }
    });
}

// This function is called automatically by YouTube IFrame API when ready
function onYouTubeIframeAPIReady() {
    initYouTubePlayer();
}

// Also try to initialize when DOM is ready (in case API loads first)
window.addEventListener('DOMContentLoaded', () => {
    if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
        initYouTubePlayer();
    }
});

function onPlayerReady(event) {
    event.target.playVideo();
    updateActiveThumbnail(0);
}

function onPlayerStateChange(event) {
    // When video ends (state 0), play next video
    if (event.data === YT.PlayerState.ENDED) {
        playNextVideo();
    }
}

function playNextVideo() {
    currentVideoIndex = (currentVideoIndex + 1) % videos.length;
    player.loadVideoById(videos[currentVideoIndex].id);
    updateActiveThumbnail(currentVideoIndex);
}

function playVideo(index) {
    currentVideoIndex = index;
    player.loadVideoById(videos[index].id);
    updateActiveThumbnail(index);
}

function updateActiveThumbnail(index) {
    const thumbnails = document.querySelectorAll('.video-thumbnail');
    thumbnails.forEach((thumb, i) => {
        if (i === index) {
            thumb.classList.add('active');
        } else {
            thumb.classList.remove('active');
        }
    });
}

// Generate thumbnails
function generateThumbnails() {
    const grid = document.getElementById('thumbnailGrid');
    
    videos.forEach((video, index) => {
        const thumbnail = document.createElement('div');
        thumbnail.className = 'video-thumbnail';
        thumbnail.onclick = () => playVideo(index);
        
        thumbnail.innerHTML = `
            <img src="${video.thumbnail}" alt="${video.title}" class="aspect-video w-full object-cover">
        `;
        
        grid.appendChild(thumbnail);
    });
}

// Initialize thumbnails when page loads
window.addEventListener('DOMContentLoaded', generateThumbnails);
// SCRIPT FOR BRIDGE KIT PAGE
